export const ContractInformationFormName = 'contract-information';

export enum ContractDetailsFormFields {
  Name = 'name',
  ContractType = 'contractType',
  StartDate = 'startDate',
  ExpirationDate = 'expirationDate',
}
